module.exports = __webpack_public_path__ + "media/images/admin/dueldonkey-logo-lila-a79b25a030d1612b17a665c476e9f705.svg";